import { z } from "zod";
import { PublicIdSchema } from "./common";

export const Weather = z.enum(["sunny", "cloudy", "rainy", "snowy", "other"]);

export const DriverAttendance = z.object({
  public_id: PublicIdSchema,
  work_date: z.iso.date(),
  clock_in_at: z.iso.datetime({ offset: true }).nullable(),
  clock_out_at: z.iso.datetime({ offset: true }).nullable(),
  weather: Weather.nullable(),
  odometer_start: z.number().int().nullable(),
  odometer_end: z.number().int().nullable(),
  notes: z.string().nullable(),
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }),
});

export const DriverDeliverySafety = z.object({
  allowed: z.boolean(),
  latest_result: z.enum(["pass", "fail"]).nullable(),
  reason: z
    .enum(["no_attendance", "no_alcohol_check", "alcohol_failed", "lookup_failed"])
    .nullable(),
});

export const ClockInInput = z.object({
  idempotency_key: PublicIdSchema.optional(),
  occurred_at: z.iso.datetime({ offset: true }).optional(),
  vehicle_public_id: PublicIdSchema.optional(),
  weather: Weather.optional(),
  odometer_start: z.number().int().min(0).optional(),
  latitude: z.string().optional(),
  longitude: z.string().optional(),
  notes: z.string().optional(),
  // F16 安全/法令: 点呼結果を出勤記録と一体で保存する。fail でも出勤は記録するが配送は許可しない。
  alcohol_result: z.enum(["pass", "fail"]),
  alcohol_measured_value: z.number().nonnegative().optional(),
});

export const ClockOutInput = z.object({
  idempotency_key: PublicIdSchema.optional(),
  occurred_at: z.iso.datetime({ offset: true }).optional(),
  odometer_end: z.number().int().min(0).optional(),
  latitude: z.string().optional(),
  longitude: z.string().optional(),
  notes: z.string().optional(),
});

export type DriverAttendanceDto = z.infer<typeof DriverAttendance>;
export type DriverDeliverySafetyDto = z.infer<typeof DriverDeliverySafety>;
export type ClockInInputDto = z.infer<typeof ClockInInput>;
export type ClockOutInputDto = z.infer<typeof ClockOutInput>;
